<template>
  <v-app-bar app :class="{ 'navbar--lcap-mobile': isMobile && isModuleNav }" :height="isMobile && isModuleNav ? 108 : undefined">
    <div v-if="isMobile">
      <v-app-bar-nav-icon @click="updateDrawer"></v-app-bar-nav-icon>
    </div>

    <div class="home-brand" @click="goToHome">
      <v-avatar>
        <v-img :src="logo" alt="ExposomeX Logo"></v-img>
      </v-avatar>
      <div v-if="!isMobile" class="text-sm-caption text-md-caption text-lg-h6">&ensp;ExposomeX</div>
    </div>
    <v-spacer></v-spacer>

    <!-- Normal navigation (hidden on /treat, /lcap, /epic, /wpn, and /umr) -->
    <template v-if="!isModuleNav">
      <v-btn size="large" v-if="!isMobile" active-color="primary" to="/">{{ $t('message.home') }}</v-btn>
      <v-menu v-if="!isMobile"  >
      <template v-slot:activator="{ props }">
        <v-btn size="large" active-color="primary" v-bind="props">
          {{ $t('message.tutorials') }}
          <v-icon
              icon="mdi-menu-down-outline"
              end
          ></v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item to="/tutorials-video" >
          <v-list-item-title >{{ $t('message.video') }}</v-list-item-title>
        </v-list-item>
        <v-list-item to="/tutorials-web">
          <v-list-item-title>{{ $t('message.web') }}</v-list-item-title>
        </v-list-item>
        <v-list-item to="/tutorials-r">
          <v-list-item-title>{{ $t('message.r') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      <v-btn size="large" v-if="!isMobile" active-color="primary" to="/download">{{ $t('message.download') }}</v-btn>
      <v-btn size="large" v-if="!isMobile" active-color="primary" to="/publication">{{ $t('message.publication') }}</v-btn>
      <v-btn size="large" v-if="!isMobile" active-color="primary" to="/user-stats">{{ $t('message.userStats') }}</v-btn>
      <v-menu v-if="!isMobile"  >
        <template v-slot:activator="{ props }">
          <v-btn size="large" active-color="primary" v-bind="props">
            {{ $t('message.version') }}
            <v-icon
              icon="mdi-menu-down-outline"
              end
            ></v-icon>
          </v-btn>
        </template>
        <v-list>
              <v-list-item @click="goToExposomexWebsite">
                <v-list-item-title style="font-size: 0.95em; cursor: pointer;">
                {{ $t('message.v1') }}
                </v-list-item-title>
              </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="!isMobile"  >
        <template v-slot:activator="{ props }">
          <v-btn size="large" active-color="primary" v-bind="props">
            {{ $t('message.About') }}
            <v-icon
              icon="mdi-menu-down-outline"
              end
            ></v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/expo" >
            <v-list-item-title >{{ $t('message.ExposomeX') }}</v-list-item-title>
              </v-list-item>
              <v-list-item  to="/update-history">
                  <v-list-item-title>{{ $t('message.updateHistory') }}</v-list-item-title>
              </v-list-item>
              <v-list-item to="/people">
                  <v-list-item-title>{{ $t('message.Team') }}</v-list-item-title>
              </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <!-- Threat Page Navigation -->
    <template v-else-if="isTreat">
        <div class="lcap-module-nav" :class="{ 'lcap-module-nav--mobile': isMobile }">
          <v-btn
            class="lcap-home-btn"
            :size="isMobile ? 'small' : 'large'"
            :active="!$route.params.topTab"
            active-color="primary"
            aria-label="TREAT home"
            to="/treat"
          >
            <v-icon :size="isMobile ? 20 : 24">mdi-home</v-icon>
          </v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'introduction'" active-color="primary" to="/treat/introduction/Description">INTRODUCTION</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'chemical'" active-color="primary" to="/treat/chemical/Description">CHEMICAL</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'disease'" active-color="primary" to="/treat/disease/Description">DISEASE</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'exposure'" active-color="primary" to="/treat/exposure/Description">EXPOSURE</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'association'" active-color="primary" to="/treat/association/Description">ASSOCIATION</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'risk'" active-color="primary" to="/treat/risk/Description">RISK</v-btn>
        </div>
      </template>

    <!-- LCAP Page Navigation -->
    <template v-else-if="isLcap">
        <div class="lcap-module-nav" :class="{ 'lcap-module-nav--mobile': isMobile }">
          <v-btn
            class="lcap-home-btn"
            :size="isMobile ? 'small' : 'large'"
            :active="!$route.params.topTab"
            active-color="primary"
            aria-label="LCAP home"
            to="/lcap"
          >
            <v-icon :size="isMobile ? 20 : 24">mdi-home</v-icon>
          </v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'introduction'" active-color="primary" to="/lcap/introduction/Description">OVERVIEW</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'bap'" active-color="primary" to="/lcap/bap/Figure">BAP</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'paf'" active-color="primary" to="/lcap/paf/Figure">PAF</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'gbd'" active-color="primary" to="/lcap/gbd/Figure">GBD</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'rank'" active-color="primary" to="/lcap/rank/Figure">RANK</v-btn>
        </div>
      </template>

    <!-- UMR Page Navigation -->
    <template v-else-if="isUmrPage">
        <div class="lcap-module-nav" :class="{ 'lcap-module-nav--mobile': isMobile }">
          <v-btn
            class="lcap-home-btn"
            :size="isMobile ? 'small' : 'large'"
            :active="!$route.params.topTab"
            active-color="primary"
            aria-label="UMR home"
            to="/umr"
          >
            <v-icon :size="isMobile ? 20 : 24">mdi-home</v-icon>
          </v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'Overview' || $route.params.topTab === 'overview'" active-color="primary" to="/umr/Overview/Description">OVERVIEW</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'URB' || $route.params.topTab === 'urb'" active-color="primary" to="/umr/URB/Figure">URBAN</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'TM7' || $route.params.topTab === 'tm7'" active-color="primary" to="/umr/TM7/Figure">TM7</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'UHRI' || $route.params.topTab === 'uhri'" active-color="primary" to="/umr/UHRI/Figure">UHRI</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'DRP' || $route.params.topTab === 'drp'" active-color="primary" to="/umr/DRP/Figure">DRP</v-btn>
        </div>
      </template>

    <!-- EPIC Page Navigation -->
    <template v-else-if="isEpic">
        <div class="lcap-module-nav" :class="{ 'lcap-module-nav--mobile': isMobile }">
          <v-btn
            class="lcap-home-btn"
            :size="isMobile ? 'small' : 'large'"
            :active="!$route.params.topTab"
            active-color="primary"
            aria-label="EPIC home"
            to="/epic"
          >
            <v-icon :size="isMobile ? 20 : 24">mdi-home</v-icon>
          </v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'introduction'" active-color="primary" to="/epic/introduction/Description">INTRODUCTION</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'emissions'" active-color="primary" to="/epic/emissions/Figure">EMISSIONS</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'association'" active-color="primary" to="/epic/association/Figure">ASSOCIATION</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'priority'" active-color="primary" to="/epic/priority/Figure">PRIORITY</v-btn>
        </div>
      </template>

    <!-- WPN Page Navigation -->
    <template v-else-if="isWpn">
        <div class="lcap-module-nav" :class="{ 'lcap-module-nav--mobile': isMobile }">
          <v-btn
            class="lcap-home-btn"
            :size="isMobile ? 'small' : 'large'"
            :active="!$route.params.topTab"
            active-color="primary"
            aria-label="WPN home"
            to="/wpn"
          >
            <v-icon :size="isMobile ? 20 : 24">mdi-home</v-icon>
          </v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'introduction'" active-color="primary" to="/wpn/introduction/Description">OVERVIEW</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'wastewater'" active-color="primary" to="/wpn/wastewater/Figure">WASTEWATER</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'wpn'" active-color="primary" to="/wpn/wpn/Figure">WPN</v-btn>
          <v-btn :size="isMobile ? 'small' : 'large'" :active="$route.params.topTab === 'rank'" active-color="primary" to="/wpn/rank/Figure">RANK</v-btn>
        </div>
      </template>
  <!-- User Dropdown Menu -->
    <v-menu offset-y>
      <!-- <template v-slot:activator="{ on, attrs, props }"> -->
      <template v-slot:activator="{ props }">
        <!-- <v-avatar v-bind="attrs" v-on="on">
          <v-img :src="head" alt="User Avatar"></v-img>
        </v-avatar> -->
        <v-avatar>
          <v-img :src="head" alt="User Avatar"></v-img>
        </v-avatar>

        <!-- 动态显示用户名或默认的 dashboard -->
        <v-btn size="large"  active-color="primary" v-bind="props" style="padding-left: 0px;">
          {{ isLoggedIn ? username : $t('message.userDashboard') }}
          <v-icon
              icon="mdi-menu-down-outline"
              end
            ></v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="isLoggedIn" @click="viewProfile">
          <v-list-item-title>{{ $t('message.profile') }}</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="isLoggedIn" @click="goToEditUsername">
          <v-list-item-title>{{ $t('message.changeProfile') }}</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="isLoggedIn" @click="goToChangePassword">
          <v-list-item-title>{{ $t('message.changePassword') }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isLoggedIn" to="/contacts">
            <v-list-item-title>{{ $t('message.Contacts') }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isLoggedIn" @click="goToLogin">
          <v-list-item-title>{{ $t('message.login') }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isLoggedIn" @click="goToRegister">
          <v-list-item-title>{{ $t('message.register') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="switchLanguage">
          <v-list-item-title>{{ $t('message.languageSwitch') }}</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="isLoggedIn" @click="logout">
          <v-list-item-title>{{ $t('message.logout') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
  <!-- 图片展示 -->
  <!-- <v-img v-if="imageSrc" :src="imageSrc" class="mt-4" max-height="400"></v-img> -->

</template>

<script>
import logo from '@/assets/logo.png';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  name: 'NavBar',
  data() {
    return {
      head: null,  // 头像 URL（ObjectURL）
      logo,
    };
  },
  created() {
    this.loadInfo(); // 在组件创建时调用
  },
  beforeUnmount() {
    // 释放 ObjectURL，避免内存泄漏
    if (this.head && this.head.startsWith('blob:')) {
      URL.revokeObjectURL(this.head);
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'username']), // 映射登录状态和用户名
    isMobile() {
      return this.$vuetify.display.mobile;
    },
    isTreat() {
      return this.$route.path.startsWith('/treat');
    },
    isLcap() {
      return this.$route.path.startsWith('/lcap');
    },
    isUmrPage() {
      return this.$route.path.startsWith('/umr');
    },
    isEpic() {
      return this.$route.path.startsWith('/epic');
    },
    isWpn() {
      return this.$route.path.startsWith('/wpn');
    },
    isModuleNav() {
      return this.isTreat || this.isLcap || this.isUmrPage || this.isEpic || this.isWpn;
    },
  },
  watch: {
    // 监听登录状态变化，自动刷新头像
    isLoggedIn: {
      handler(newValue, oldValue) {
        console.log('登录状态变化:', oldValue, '->', newValue);
        // 当登录状态发生变化时，重新加载头像信息
        this.loadInfo();
      },
      immediate: false
    }
  },
  methods: {
    ...mapMutations(['updateDrawer']),
    async loadInfo() {
      // 如果用户未登录，加载默认头像
      if (!this.isLoggedIn) {
        try {
          // 后端会返回默认头像，传入一个不存在的 user_id 或空字符串
          const avatarResponse = await axios.post('/api/user/GetUserAvatar/', {
            user_id: '0'  // 使用 0 表示获取默认头像
          }, {
            responseType: 'blob'
          });

          // 将 blob 转换为 ObjectURL
          this.head = URL.createObjectURL(avatarResponse.data);
          console.log('默认头像加载成功');
        } catch (error) {
          console.error('加载默认头像失败:', error);
          this.head = null;
        }
        return;
      }

      try {
        // 获取用户信息
        var data = new FormData();
        const access_token = localStorage.getItem('access_token');
        data.append('access_token', access_token);
        const response = await axios.post('/api/user/GetTokenInfoView/', data);

        // 使用新的头像接口获取头像（后端会自动处理默认头像）
        if (response.data.user_id) {
          try {
            const avatarResponse = await axios.post('/api/user/GetUserAvatar/', {
              user_id: response.data.user_id
            }, {
              responseType: 'blob'
            });

            // 释放旧的 ObjectURL（如果存在）
            if (this.head && this.head.startsWith('blob:')) {
              URL.revokeObjectURL(this.head);
            }

            // 将 blob 转换为 ObjectURL
            this.head = URL.createObjectURL(avatarResponse.data);
            console.log('用户头像加载成功');
          } catch (avatarError) {
            console.error('获取头像失败:', avatarError);
            // 后端应该会返回默认头像，所以这里一般不会失败
            // 如果真的失败了，保持当前头像不变
          }
        }
      } catch (error) {
        console.error('加载用户信息失败:', error.response ? error.response.data : error.message);
        // 发生错误时，尝试加载默认头像
        try {
          const avatarResponse = await axios.post('/api/user/GetUserAvatar/', {
            user_id: '0'
          }, {
            responseType: 'blob'
          });
          this.head = URL.createObjectURL(avatarResponse.data);
        } catch (defaultAvatarError) {
          console.error('加载默认头像也失败:', defaultAvatarError);
        }
      }
    },
    viewProfile() {
      this.$router.push('/dashboard');
    },
    goToChangePassword() {
      this.$router.push('/change-password');
    },
    goToEditUsername() {
      this.$router.push('/edit-username');
    },
    async logout() {
      try {
        await axios.post('/api/user/LogoutView/', { access_token: localStorage.getItem('access_token') });
        localStorage.removeItem('access_token');
        this.$store.dispatch('logout');
        this.$router.push('/login?reload=$(Date.now())');
      } catch (error) {
        console.error('Logout error:', error.response ? error.response.data : error.message);
      }
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToHome() {
      this.$router.push('/');
    },
    // goToHome() {
    //   const access_token = localStorage.getItem('access_token');
    //   const home = `http://qgserver.tpddns.cn:58609/#/?access_token=${access_token}`;
    //   window.location.href = home;
    // },
    goToRegister() {
      this.$router.push('/register');
    },
    switchLanguage() {
      const currentLocale = this.$i18n.locale;
      this.$i18n.locale = currentLocale === 'en' ? 'zh' : 'en';
      localStorage.setItem('language', this.$i18n.locale);
    },
    goToExposomexWebsite() {
      const url = 'http://v1.exposomex.cn:80/#/home';
      window.open(url, '_blank', 'noopener,noreferrer');
    },
  },
  mounted() {
    const savedLocale = localStorage.getItem('language');
    if (savedLocale) {
      this.$i18n.locale = savedLocale;
    }
  },
};
</script>

<style>
.home-brand {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.navbar--lcap-mobile.v-toolbar {
  height: auto !important;
}

.navbar--lcap-mobile .v-toolbar__content {
  height: auto !important;
  flex-wrap: wrap;
  align-content: stretch;
  overflow: visible;
}

.lcap-module-nav {
  display: flex;
  align-items: center;
}

.lcap-home-btn {
  min-width: 44px;
  padding: 0 8px;
}

.lcap-module-nav--mobile {
  order: 1;
  flex: 1 0 100%;
  justify-content: space-evenly;
  gap: 2px;
  overflow-x: auto;
  border-top: 1px solid #e6edf5;
  background: #fff;
}

.lcap-module-nav--mobile .v-btn {
  min-width: 0;
  padding: 0 6px;
  letter-spacing: 0;
}
</style>
